module.exports = __webpack_public_path__ + "static/media/failed-capture-seven.2b80c9eb.png";